import { useState } from 'react';
import {
    FormControl,
    Stack,
    FormLabel,
    Box,
    Text,
    HStack,
    Switch,
} from '@chakra-ui/react';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
    descriptionStyling,
} from 'components/forms/new/formStyles';
import FieldToolTip from 'components/forms/new/FieldToolTip';

const PublicPoolField = ({
    darkMode,
    values,
    setFieldValue,
    ufPublicPoolCheckbox,
}) => {
    const [isHovered, setIsHovered] = useState(false);

    // Prevent label click from toggling switch
    const handleLabelClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={stackStyling(true)}>
                <Box onClick={handleLabelClick}>
                    <FormLabel
                        sx={formLabelStyling(darkMode)}
                        htmlFor={undefined}
                        onClick={handleLabelClick}>
                        Public Pool
                    </FormLabel>
                    <Text
                        sx={descriptionStyling}
                        maxWidth={250}
                        onClick={handleLabelClick}>
                        Mark this number block as available in the public pool.
                    </Text>
                </Box>
                <Box flex="1" minWidth={0}>
                    <Box
                        sx={{
                            display: 'flex',
                            width: '100%',
                            alignItems: 'center',
                            paddingTop: '20px',
                        }}>
                        <HStack spacing={4} alignItems="center">
                            <Switch
                                id="public-pool-switch"
                                isChecked={values.publicPool}
                                onChange={(e) => {
                                    e.stopPropagation();
                                    setFieldValue(
                                        'publicPool',
                                        !values.publicPool,
                                    );
                                }}
                                data-walkthroughid={ufPublicPoolCheckbox}
                                colorScheme="brand"
                            />
                            {isHovered && (
                                <Box
                                    display="flex"
                                    alignItems="center"
                                    ml={3}
                                    position="relative"
                                    top="2px">
                                    <FieldToolTip
                                        label="Mark this number block as available in the public pool."
                                        ariaLabel="public-pool-tip"
                                        left="5px"
                                        bottom="5px"
                                    />
                                </Box>
                            )}
                        </HStack>
                    </Box>
                </Box>
            </Stack>
        </FormControl>
    );
};

export default PublicPoolField;
